import { Link } from 'react-router-dom';
import SEOHead from '../../components/base/SEOHead';
import Header from '../../components/feature/Header';

export default function Home() {
  const homeSchema = [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "おかやま警備株式会社",
      "description": "倉敷市を中心に交通誘導警備サービスを提供する地域密着型の警備会社",
      "url": "SITE_URL_PLACEHOLDER/",
      "telephone": "+81-86-012-3456",
      "faxNumber": "+81-86-012-3457",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "○○町1-2-3",
        "addressLocality": "岡山市北区",
        "addressRegion": "岡山県",
        "postalCode": "700-0000",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "34.5951",
        "longitude": "133.7381"
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      "areaServed": {
        "@type": "City",
        "name": "倉敷市"
      },
      "priceRange": "$$"
    },
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "交通誘導警備サービス",
      "provider": {
        "@type": "LocalBusiness",
        "name": "おかやま警備株式会社"
      },
      "areaServed": {
        "@type": "City",
        "name": "倉敷市"
      },
      "description": "道路工事現場、建設現場、イベント会場、商業施設での交通誘導警備サービス"
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "倉敷市内であれば即日対応は可能ですか?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "はい、倉敷市内であれば最短即日対応が可能です。ただし、警備員の配置状況によりますので、まずはお電話でご相談ください。緊急の場合も柔軟に対応いたします。"
          }
        },
        {
          "@type": "Question",
          "name": "料金はどのように決まりますか?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "警備時間、人員数、現場の状況などにより料金が変動します。まずは現場の状況をお聞かせいただき、最適なプランとお見積りをご提案させていただきます。お気軽にお問い合わせください。"
          }
        },
        {
          "@type": "Question",
          "name": "有資格者の配置は可能ですか?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "はい、交通誘導警備業務検定合格者の配置が可能です。現場の規模や要件に応じて、適切な資格を持つスタッフを配置いたします。"
          }
        },
        {
          "@type": "Question",
          "name": "夜間や早朝の警備も対応していますか?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "はい、24時間対応可能です。夜間工事や早朝の作業にも対応しておりますので、時間帯に関わらずご相談ください。"
          }
        },
        {
          "@type": "Question",
          "name": "倉敷市以外のエリアでも対応可能ですか?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "はい、岡山県内全域に対応しております。倉敷市近隣の総社市、早島町はもちろん、岡山市や県内各地での警備実績がございます。エリアによって対応時間が異なる場合がありますので、詳細はお問い合わせください。"
          }
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="倉敷市交通誘導警備｜おかやま警備株式会社｜地域密着の安全サポート"
        description="倉敷市を中心に交通誘導警備サービスを提供するおかやま警備株式会社。道路工事、建設現場、イベント会場での確かな技術と丁寧な対応で地域の安全を守ります。即日対応可能。交通誘導警備業務検定合格者在籍。倉敷市内の工事現場やイベントでの豊富な実績があり、お客様から高い評価をいただいています。"
        keywords="倉敷市,交通誘導警備,警備会社,道路工事,建設現場警備,イベント警備,駐車場誘導,岡山県,安全管理"
        canonical="/"
        schema={homeSchema}
      />
      <Header />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center bg-cover bg-center" style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://static.readdy.ai/image/cf115492d066f9ab249365df72980427/3c34548b347fa997d1997a7e68d7f37f.jpeg')`}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">倉敷の街を守る<br />信頼の交通誘導</h2>
          <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto">確かな技術と丁寧な対応で、工事現場や各種イベントの安全を確保します。</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href="tel:086-012-3456" className="bg-blue-900 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-800 whitespace-nowrap cursor-pointer inline-flex items-center justify-center">
              <i className="ri-phone-fill mr-2"></i>今すぐ電話でご相談ください
            </a>
            <a href="#contact" className="bg-white text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 whitespace-nowrap cursor-pointer inline-flex items-center justify-center">
              <i className="ri-mail-fill mr-2"></i>お問い合わせフォーム
            </a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">おかやま警備が選ばれる理由</h2>
            <p className="text-xl text-gray-600">倉敷市・岡山市を中心に、地域の安全を守り続けています</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-medal-line text-4xl text-blue-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">豊富な実績と経験</h3>
              <p className="text-gray-600 leading-relaxed">倉敷市を中心に数多くの工事現場やイベントで交通誘導警備を実施。長年培った経験と確かな技術で、あらゆる現場に対応します。道路工事、建設現場、イベント会場など、多様な環境での警備実績があります。</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-team-line text-4xl text-blue-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">有資格者による安心対応</h3>
              <p className="text-gray-600 leading-relaxed">交通誘導警備業務検定合格者が在籍し、専門的な知識と技術を持ったスタッフが対応します。定期的な研修と訓練により、常に最新の安全基準に準拠した警備サービスを提供しています。</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-time-line text-4xl text-blue-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">迅速な対応力</h3>
              <p className="text-gray-600 leading-relaxed">倉敷市内であれば最短即日対応可能。急な工事や緊急の警備依頼にも柔軟に対応します。24時間365日の連絡体制で、お客様のニーズに素早くお応えします。地域密着だからこそできる機動力が強みです。</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">主な事業内容</h2>
            <p className="text-xl text-gray-600">様々な現場で安全を確保する交通誘導警備サービス</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl overflow-hidden shadow-lg">
              <img src="https://public.readdy.ai/ai/img_res/950ff66888c22dc5cd1efa026ae18fb0.jpg" alt="道路工事現場での交通誘導" className="w-full h-64 object-cover object-top" />
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">道路工事現場の交通誘導</h3>
                <p className="text-gray-600 leading-relaxed mb-4">道路工事や舗装工事における車両・歩行者の安全な誘導を行います。工事区間の適切な交通規制と円滑な交通流の確保により、事故を未然に防ぎます。倉敷市内の主要道路から生活道路まで、あらゆる道路工事に対応可能です。</p>
                <Link to="/services" className="text-blue-900 font-semibold hover:text-blue-700 cursor-pointer whitespace-nowrap inline-flex items-center">
                  詳しく見る <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
            <div className="bg-white rounded-xl overflow-hidden shadow-lg">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20security%20personnel%20managing%20traffic%20at%20building%20construction%20site%20entrance%2C%20professional%20uniform%2C%20safety%20equipment%2C%20organized%20site%20with%20construction%20materials%2C%20daytime%20clear%20weather%2C%20professional%20photography%20style&width=800&height=500&seq=service002&orientation=landscape" alt="建設現場での警備" className="w-full h-64 object-cover object-top" />
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">建設現場の警備</h3>
                <p className="text-gray-600 leading-relaxed mb-4">ビル建設や住宅建築現場での車両誘導と安全管理を実施します。工事車両の出入り管理、資材搬入時の交通整理など、建設現場特有のニーズに対応。近隣住民への配慮も含めた総合的な警備サービスを提供します。</p>
                <Link to="/services" className="text-blue-900 font-semibold hover:text-blue-700 cursor-pointer whitespace-nowrap inline-flex items-center">
                  詳しく見る <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
            <div className="bg-white rounded-xl overflow-hidden shadow-lg">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20security%20staff%20directing%20vehicles%20at%20outdoor%20event%20parking%20area%2C%20professional%20appearance%2C%20organized%20parking%20lot%20with%20clear%20signage%2C%20daytime%20sunny%20weather%2C%20people%20and%20cars%20visible%2C%20professional%20photography&width=800&height=500&seq=service003&orientation=landscape" alt="イベント会場での誘導" className="w-full h-64 object-cover object-top" />
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">イベント会場の交通整理</h3>
                <p className="text-gray-600 leading-relaxed mb-4">祭りやスポーツイベント、コンサートなどの大規模イベントにおける駐車場誘導と交通整理を行います。来場者の安全確保と円滑な車両誘導により、イベントの成功をサポート。倉敷市内の各種イベントで豊富な実績があります。</p>
                <Link to="/services" className="text-blue-900 font-semibold hover:text-blue-700 cursor-pointer whitespace-nowrap inline-flex items-center">
                  詳しく見る <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
            <div className="bg-white rounded-xl overflow-hidden shadow-lg">
              <img src="https://readdy.ai/api/search-image?query=Japanese%20security%20guard%20at%20commercial%20facility%20parking%20lot%20entrance%2C%20professional%20uniform%2C%20modern%20shopping%20center%20background%2C%20organized%20parking%20area%2C%20daytime%20clear%20weather%2C%20professional%20photography%20style&width=800&height=500&seq=service004&orientation=landscape" alt="商業施設での警備" className="w-full h-64 object-cover object-top" />
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">商業施設の駐車場警備</h3>
                <p className="text-gray-600 leading-relaxed mb-4">ショッピングセンターや商業施設の駐車場における交通誘導と安全管理を実施。混雑時の円滑な車両誘導、歩行者の安全確保、トラブル対応など、お客様が安心して利用できる環境づくりをサポートします。</p>
                <Link to="/services" className="text-blue-900 font-semibold hover:text-blue-700 cursor-pointer whitespace-nowrap inline-flex items-center">
                  詳しく見る <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Area */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">対応エリア</h2>
            <p className="text-xl text-gray-600">倉敷市を中心に岡山県内全域に対応しています</p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="bg-blue-50 p-8 rounded-xl mb-6">
                <h3 className="text-2xl font-bold text-blue-900 mb-4 flex items-center">
                  <i className="ri-map-pin-fill mr-3"></i>主要対応エリア
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-blue-900 mr-3 mt-1"></i>
                    <span><strong className="text-gray-900">倉敷市全域：</strong>倉敷駅周辺、水島地区、児島地区、玉島地区など市内全エリアに迅速対応</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-blue-900 mr-3 mt-1"></i>
                    <span><strong className="text-gray-900">岡山市：</strong>北区、中区、東区、南区の各エリアでの交通誘導警備に対応</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-blue-900 mr-3 mt-1"></i>
                    <span><strong className="text-gray-900">総社市・早島町：</strong>倉敷市近隣エリアも迅速に対応可能</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-blue-900 mr-3 mt-1"></i>
                    <span><strong className="text-gray-900">その他岡山県内：</strong>県内全域対応可能、詳細はお問い合わせください</span>
                  </li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl">
                <p className="text-gray-700 leading-relaxed">
                  <i className="ri-information-line text-blue-900 mr-2"></i>
                  倉敷市内であれば<strong className="text-blue-900">最短即日対応</strong>が可能です。その他のエリアについてもお気軽にご相談ください。
                </p>
              </div>
            </div>
            <div className="h-96 rounded-xl overflow-hidden shadow-lg">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52634.89384649384!2d133.7381!3d34.5951!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3551178a1e1e1e1f%3A0x1e1e1e1e1e1e1e1e!2z5YCS5pWt5biC!5e0!3m2!1sja!2sjp!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="倉敷市地図"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">お客様の声</h2>
            <p className="text-xl text-gray-600">倉敷市内の企業様から高い評価をいただいています</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="flex items-center mb-4">
                <img src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20male%20construction%20company%20manager%20in%20business%20suit%2C%20confident%20expression%2C%20office%20background%2C%20professional%20headshot%20photography%2C%20realistic%2C%20high%20quality&width=100&height=100&seq=testimonial001&orientation=squarish" alt="建設会社A社様" className="w-16 h-16 rounded-full object-cover object-top mr-4" />
                <div>
                  <h4 className="font-bold text-gray-900">建設会社A社様</h4>
                  <p className="text-sm text-gray-600">倉敷市内の建設現場</p>
                </div>
              </div>
              <div className="flex mb-3">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">「長年お世話になっています。スタッフの方々の対応が丁寧で、現場の安全管理も徹底されています。倉敷市内の複数の現場で依頼していますが、いつも迅速に対応していただけるので助かっています。」</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="flex items-center mb-4">
                <img src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20event%20coordinator%20in%20business%20attire%2C%20friendly%20smile%2C%20modern%20office%20setting%2C%20professional%20headshot%20photography%2C%20realistic%2C%20high%20quality&width=100&height=100&seq=testimonial002&orientation=squarish" alt="イベント企画会社B社様" className="w-16 h-16 rounded-full object-cover object-top mr-4" />
                <div>
                  <h4 className="font-bold text-gray-900">イベント企画会社B社様</h4>
                  <p className="text-sm text-gray-600">倉敷市内のイベント</p>
                </div>
              </div>
              <div className="flex mb-3">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">「大規模イベントでの駐車場誘導をお願いしました。来場者への対応が親切で、トラブルもなくスムーズに進行できました。地域のことをよく理解されているので、安心して任せられます。」</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="flex items-center mb-4">
                <img src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20male%20facility%20manager%20in%20business%20casual%20attire%2C%20confident%20appearance%2C%20commercial%20building%20background%2C%20professional%20headshot%20photography%2C%20realistic%2C%20high%20quality&width=100&height=100&seq=testimonial003&orientation=squarish" alt="商業施設C社様" className="w-16 h-16 rounded-full object-cover object-top mr-4" />
                <div>
                  <h4 className="font-bold text-gray-900">商業施設C社様</h4>
                  <p className="text-sm text-gray-600">倉敷市内の商業施設</p>
                </div>
              </div>
              <div className="flex mb-3">
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
                <i className="ri-star-fill text-yellow-400"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">「駐車場の警備を定期的にお願いしています。繁忙期の混雑時も的確に誘導していただき、お客様からのクレームもありません。プロフェッショナルな対応に感謝しています。」</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">よくあるご質問</h2>
            <p className="text-xl text-gray-600">交通誘導警備に関するお問い合わせ</p>
          </div>
          <div className="space-y-6">
            <div className="bg-gray-50 p-8 rounded-xl">
              <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-start">
                <i className="ri-question-line text-blue-900 mr-3 mt-1"></i>
                <a href="#faq1" id="faq1">倉敷市内であれば即日対応は可能ですか？</a>
              </h4>
              <p className="text-gray-700 leading-relaxed ml-9">はい、倉敷市内であれば最短即日対応が可能です。ただし、警備員の配置状況によりますので、まずはお電話でご相談ください。緊急の場合も柔軟に対応いたします。</p>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl">
              <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-start">
                <i className="ri-question-line text-blue-900 mr-3 mt-1"></i>
                <a href="#faq2" id="faq2">料金はどのように決まりますか？</a>
              </h4>
              <p className="text-gray-700 leading-relaxed ml-9">警備時間、人員数、現場の状況などにより料金が変動します。まずは現場の状況をお聞かせいただき、最適なプランとお見積りをご提案させていただきます。お気軽にお問い合わせください。</p>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl">
              <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-start">
                <i className="ri-question-line text-blue-900 mr-3 mt-1"></i>
                <a href="#faq3" id="faq3">有資格者の配置は可能ですか？</a>
              </h4>
              <p className="text-gray-700 leading-relaxed ml-9">はい、交通誘導警備業務検定合格者の配置が可能です。現場の規模や要件に応じて、適切な資格を持つスタッフを配置いたします。</p>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl">
              <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-start">
                <i className="ri-question-line text-blue-900 mr-3 mt-1"></i>
                <a href="#faq4" id="faq4">夜間や早朝の警備も対応していますか？</a>
              </h4>
              <p className="text-gray-700 leading-relaxed ml-9">はい、24時間対応可能です。夜間工事や早朝の作業にも対応しておりますので、時間帯に関わらずご相談ください。</p>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl">
              <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-start">
                <i className="ri-question-line text-blue-900 mr-3 mt-1"></i>
                <a href="#faq5" id="faq5">倉敷市以外のエリアでも対応可能ですか？</a>
              </h4>
              <p className="text-gray-700 leading-relaxed ml-9">はい、岡山県内全域に対応しております。倉敷市近隣の総社市、早島町はもちろん、岡山市や県内各地での警備実績がございます。エリアによって対応時間が異なる場合がありますので、詳細はお問い合わせください。</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-blue-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">お問い合わせ</h2>
            <p className="text-xl text-blue-100">交通誘導警備のご依頼・ご相談はお気軽にどうぞ</p>
          </div>
          <div className="bg-white rounded-xl p-8 md:p-12">
            <form data-readdy-form id="contact-form" className="space-y-6" action="https://readdy.ai/api/form/d4ja8cqeh8g2mrj4avf0" method="POST" onSubmit={(e) => {
              e.preventDefault();
              const form = e.currentTarget;
              
              const messageTextarea = form.querySelector('#message') as HTMLTextAreaElement;
              if (messageTextarea && messageTextarea.value.length > 500) {
                alert('お問い合わせ内容は500文字以内で入力してください。');
                return;
              }
              
              const formData = new FormData(form);
              const data = new URLSearchParams();
              
              formData.forEach((value, key) => {
                if (key === 'service-type') {
                  const select = form.querySelector('#service-type') as HTMLSelectElement;
                  if (select && select.value) {
                    data.append(key, select.options[select.selectedIndex].text);
                  }
                } else {
                  data.append(key, value.toString());
                }
              });
              
              fetch('https://readdy.ai/api/form/d4ja8cqeh8g2mrj4avf0', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: data.toString()
              }).then(response => {
                if (response.ok) {
                  alert('お問い合わせを送信しました。ありがとうございます。');
                  form.reset();
                } else {
                  alert('送信に失敗しました。もう一度お試しください。');
                }
              }).catch(() => {
                alert('送信に失敗しました。もう一度お試しください。');
              });
            }}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-2">お名前 <span className="text-red-600">*</span></label>
                  <input type="text" id="name" name="name" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent text-sm" />
                </div>
                <div>
                  <label htmlFor="company" className="block text-sm font-semibold text-gray-900 mb-2">会社名・団体名</label>
                  <input type="text" id="company" name="company" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent text-sm" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">メールアドレス <span className="text-red-600">*</span></label>
                  <input type="email" id="email" name="email" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent text-sm" />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-900 mb-2">電話番号 <span className="text-red-600">*</span></label>
                  <input type="tel" id="phone" name="phone" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent text-sm" />
                </div>
              </div>
              <div>
                <label htmlFor="service-type" className="block text-sm font-semibold text-gray-900 mb-2">ご希望のサービス</label>
                <div className="relative">
                  <select id="service-type" name="service-type" className="w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent appearance-none cursor-pointer text-sm bg-white">
                    <option value="">選択してください</option>
                    <option value="道路工事">道路工事現場の交通誘導</option>
                    <option value="建設現場">建設現場の警備</option>
                    <option value="イベント">イベント会場の交通整理</option>
                    <option value="商業施設">商業施設の駐車場警備</option>
                    <option value="その他">その他</option>
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-600"></i>
                </div>
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-gray-900 mb-2">お問い合わせ内容 <span className="text-red-600">*</span></label>
                <textarea id="message" name="message" required rows={6} maxLength={500} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent text-sm resize-none" placeholder="警備が必要な現場の詳細、希望日時、人員数などをご記入ください（500文字以内）"></textarea>
                <p className="text-sm text-gray-600 mt-2">※500文字以内でご入力ください</p>
              </div>
              <button type="submit" className="w-full bg-blue-900 text-white py-4 rounded-lg font-semibold hover:bg-blue-800 transition-colors whitespace-nowrap cursor-pointer text-lg">
                送信する
              </button>
            </form>
            <div className="mt-8 pt-8 border-t border-gray-200">
              <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                <div className="text-center md:text-left">
                  <p className="text-sm text-gray-600 mb-2">お急ぎの方はお電話でどうぞ</p>
                  <a href="tel:086-012-3456" className="text-2xl font-bold text-blue-900 hover:text-blue-700 cursor-pointer whitespace-nowrap inline-flex items-center">
                    <i className="ri-phone-fill mr-2"></i>086-012-3456
                  </a>
                  <p className="text-sm text-gray-600 mt-2">営業時間：9:00〜18:00（日曜・祝日を除く）</p>
                </div>
                <div className="text-center md:text-right">
                  <p className="text-sm text-gray-600 mb-2">FAXでのお問い合わせ</p>
                  <p className="text-xl font-bold text-gray-900">086-012-3457</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-bold mb-4">おかやま警備株式会社</h3>
              <p className="text-gray-400 text-sm leading-relaxed">倉敷市を中心に、確かな技術と丁寧な対応で地域の安全を守ります。</p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">サービス</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">道路工事現場の交通誘導</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">建設現場の警備</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">イベント会場の交通整理</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">商業施設の駐車場警備</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">会社情報</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/company" className="text-gray-400 hover:text-white cursor-pointer">会社概要</Link></li>
                <li><Link to="/recruit" className="text-gray-400 hover:text-white cursor-pointer">求人情報</Link></li>
                <li><Link to="/blog" className="text-gray-400 hover:text-white cursor-pointer">ブログ・新着情報</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">お問い合わせ</h4>
              <ul className="space-y-2 text-sm">
                <li className="flex items-start">
                  <i className="ri-phone-fill mr-2 mt-1"></i>
                  <a href="tel:086-012-3456" className="text-gray-400 hover:text-white cursor-pointer">086-012-3456</a>
                </li>
                <li className="flex items-start">
                  <i className="ri-printer-fill mr-2 mt-1"></i>
                  <span className="text-gray-400">086-012-3457</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-fill mr-2 mt-1"></i>
                  <span className="text-gray-400">岡山市北区○○町1-2-3</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-time-fill mr-2 mt-1"></i>
                  <span className="text-gray-400">9:00〜18:00<br />（日曜・祝日を除く）</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">&copy; 2025 おかやま警備株式会社. All rights reserved.</p>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm mt-4 md:mt-0 cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
